<template>
  <div class="plan-upgrade-overview-component">
    <h2 class="text-sm font-semibold text-[#23569F] uppercase">{{ $t('planUpgrade.Overview') }}</h2>
    <el-row class="mt-1">
      <el-col :span="16" :offset="4" class="flex flex-col">
        <div class="flex flex-col">
          <el-form @submit.prevent="triggerFormSubmit"
              ref="refOverviewForm"
              :model="model"
              class="common-form">

              <el-row class="flex-col items-center justify-center mt-1">
                <div class="w-[250px]">
                  <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.country") }}</h2>
                  <el-form-item prop="selectCountry" class="mt-2">
                    <SelectCountry :countryCode="model.countryCode" ref="country" @change="handleCountryChange"></SelectCountry>
                  </el-form-item>
                </div>
              </el-row>
              <el-row v-if="showSelectState" class="flex-col items-center justify-center mt-2">
                <div class="w-[250px]">
                  <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ `${$t('label.state')}`}}</h2>
                  <el-form-item class="us-state" prop="state">
                    <el-select v-model="model.state"
                      filterable
                      :placeholder="`${$t('planUpgrade.selectState')}`"
                      ref="selectState"
                      class="select-state"
                      :popper-class="'state-auto-complete-popper'"
                      @change="handleStateChange($event)">
                      <el-option
                        v-for="state in USStates"
                        :key="state.abbreviation"
                        :label="state.name"
                        :value="state.abbreviation">
                      </el-option>
                    </el-select>
                </el-form-item>
                </div>
              </el-row>
              <h2 v-show="errorMessage" class="error mt-2 text-xs text-red-warning block">{{ errorMessage }}</h2>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="showInvoice" class="mt-7 invoice-summary flex justify-items-center justify-center">
      <div class="bg-[#DCEAFF] w-[380px] h-[238px]">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-row class="text-xs
              font-bold
              text-black
              uppercase
              text-left
              py-6">
              <el-col :span="10" :offset="2">{{ $t('playerSetup.numberOfPlayers') }}</el-col>
              <el-col :span="10" :offset="2">{{filteredInvoiceSummary.newPlayerCount}}</el-col>
            </el-row>

            <el-divider class="invoice-h-divider"></el-divider>

            <el-row class="text-xs
              font-semibold
              text-black
              uppercase
              text-left
              py-6">
              <el-col :span="10" :offset="2">{{ $t('label.subtotal') }}</el-col>
              <el-col :span="10" :offset="2">{{filteredInvoiceSummary.subTotal}}</el-col>
            </el-row>

            <el-divider class="invoice-h-divider"></el-divider>

            <el-row class="text-xs
              font-semibold
              text-black
              uppercase
              text-left
              py-4">
              <el-col :span="10" :offset="2">{{`VAT ${filteredInvoiceSummary.vatInPercent}`}}</el-col>
              <el-col :span="10" :offset="2">{{filteredInvoiceSummary.vat}}</el-col>
            </el-row>

            <el-row class="text-xs
              font-semibold
              text-black
              uppercase
              text-left
              py-3">
              <el-col :span="10" :offset="14" class="text-lg font-bold">
                <span class="text-base">{{filteredInvoiceSummary.total}}</span>
                <span class="font-bold text-xs">/ {{$t('template.month')}}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script src="./plan-upgrade-overview.js"></script>
<style lang="scss" src="./plan-upgrade-overview.scss"></style>
